import { makeStyles, Theme } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme: Theme) => ({
  root: {
    backgroundColor: theme.palette.error.dark,
  },
  icon: {
    fontSize: 20,
    backgroundColor: 'rgba(0,0,0,0.15)',
    width: '38px',
    height: '38px',
    marginLeft: theme.spacing(1)
  },
  button: {
    color: 'white',
    backgroundColor: 'rgba(0,0,0,0.15)'
  },
  list: {
    margin: 0,
    padding: 0,
    listStyle: 'none',
  },
  listItem: {
    marginBottom: theme.spacing(1),
    '&:last-child': {
      marginBottom: 0,
    },
  },
}));
